import { Reveal } from "@/components/Reveal";
import { CoverArt } from "@/components/CoverArt";
import { Target, Eye, HandCoins, ShieldCheck } from "lucide-react";

const PRINCIPLES = [
    {
        icon: Target,
        title: "Clareza acima de tudo",
        text: "Se um conceito não pode ser explicado em português simples, ele ainda não foi bem entendido. Traduzimos o jargão do mercado para a vida real.",
    },
    {
        icon: Eye,
        title: "Transparência radical",
        text: "Todo conteúdo patrocinado e todo link de afiliado é identificado. Você sempre sabe quando alguém pagou para estar aqui — e por que escolhemos aceitar.",
    },
    {
        icon: HandCoins,
        title: "Método, não promessa",
        text: "Não vendemos enriquecimento rápido, dica quente ou curso milagroso. Publicamos matemática, hábito e paciência — as únicas coisas que funcionam.",
    },
    {
        icon: ShieldCheck,
        title: "Independência editorial",
        text: "Anunciantes compram espaço, nunca opinião. Nenhum parceiro revisa, aprova ou influencia o que escrevemos nos artigos.",
    },
];

export default function Sobre() {
    return (
        <main data-testid="sobre-page" className="pt-28 md:pt-36 pb-20">
            <div className="max-w-3xl mx-auto px-4 md:px-0">
                <span className="text-xs uppercase tracking-[0.3em] text-gold font-medium">Sobre nós</span>
                <h1 className="font-serif text-4xl md:text-6xl tracking-tight mt-4 leading-[1.05]">
                    Educação financeira para quem <span className="italic text-gold">não nasceu rico.</span>
                </h1>
                <p className="mt-8 text-base md:text-lg text-slate-300 leading-[1.85]">
                    O Investidor Comum nasceu de uma constatação simples: a educação financeira no Brasil
                    ou é técnica demais para quem está começando, ou rasa demais para fazer diferença.
                    Nosso trabalho é ocupar esse meio — com artigos que respeitam a inteligência do leitor
                    e o tamanho do seu salário.
                </p>
                <p className="mt-5 text-base md:text-lg text-slate-300 leading-[1.85]">
                    Escrevemos sobre orçamento, renda fixa, dividendos, fundos imobiliários e independência
                    financeira com um único compromisso: nada aqui é recomendação de investimento. É
                    educação — para que você tome as suas próprias decisões, com os seus próprios critérios.
                </p>
            </div>

            <div className="max-w-5xl mx-auto px-4 md:px-8 mt-14">
                <div className="border border-white/10 overflow-hidden h-56 md:h-72">
                    <CoverArt seed="sobre-investidor-comum" variant="bars" />
                </div>
            </div>

            <div className="max-w-3xl mx-auto px-4 md:px-0 mt-16">
                <h2 className="font-serif text-3xl md:text-4xl tracking-tight mb-10">Nossos princípios</h2>
                <div className="flex flex-col gap-8">
                    {PRINCIPLES.map((p, i) => (
                        <Reveal key={p.title} delay={i * 0.06}>
                            <div data-testid={`sobre-principle-${i}`} className="flex gap-5 border-b border-white/10 pb-8">
                                <span className="flex items-center justify-center w-11 h-11 border border-gold/40 text-gold shrink-0">
                                    <p.icon size={18} />
                                </span>
                                <div>
                                    <h3 className="font-serif text-xl mb-2">{p.title}</h3>
                                    <p className="text-sm md:text-base text-slate-400 leading-relaxed">{p.text}</p>
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>

                <div className="mt-14 border border-white/10 bg-paper p-6 md:p-8">
                    <h2 className="font-serif text-2xl tracking-tight mb-4">Como nos sustentamos</h2>
                    <p className="text-sm md:text-base text-slate-400 leading-relaxed">
                        O Investidor Comum é gratuito e sempre será. Somos remunerados por três fontes,
                        todas sempre identificadas: anúncios do Google AdSense (marcados como "Publicidade"),
                        produtos patrocinados (selo "Patrocinado") e links de afiliados — quando você usa
                        nossos links para conhecer uma ferramenta, podemos receber uma comissão sem custo
                        adicional para você. É isso que mantém o conteúdo independente e gratuito.
                    </p>
                </div>
            </div>
        </main>
    );
}
